// extracted by mini-css-extract-plugin
export default {"heading":"accordion_heading__Tbwac","inner":"accordion_inner__z5que","row":"accordion_row__GtJkX","caret":"accordion_caret__rD2ws"};